import TelescopeIcon from '@images/telescope.svg?react';
import BooksOnTheShelfIcon from '@images/books-on-the-shelf.svg?react';
import HatIcon from '@images/big-hat.svg?react';
import NotebookIcon from '@images/notebook.svg?react';
import CalculatorIcon from '@images/сalculator.svg?react';
import CubesIcon from '@images/cubes.svg?react';
import TargetIcon from '@images/target.svg?react';
import DegreesAwardedIcon from '@images/degrees-awarded.svg?react';
import PrizeIcon from '@images/ScholarshipsIcons/prize.svg?react';

const createEnumFromArray = <T extends string | number>(strings: readonly T[]) =>
  strings.reduce((acc, str) => ({ ...acc, [str]: str }), {} as { [key in T]: key });

export const PAGE_SECTION_IDS = [
  'about',
  'general-information',
  'areas-of-study',
  'degrees-awarded',
  'admissions',
  'tuition-cost-aid',
  'scholarship',
  'students-outcomes',
  'extracurricular-activities',
] as const;

export const PageSectionIds = createEnumFromArray(PAGE_SECTION_IDS);
export type PageSectionId = keyof typeof PageSectionIds;

export const SIDEBAR_DATA = [
  {
    id: 1,
    title: 'About',
    icon: <TelescopeIcon />,
    value: PageSectionIds.about,
  },
  {
    id: 2,
    title: 'General information',
    icon: <BooksOnTheShelfIcon />,
    value: PageSectionIds['general-information'],
  },
  {
    id: 3,
    title: 'Areas of study and programs',
    icon: <HatIcon />,
    value: PageSectionIds['areas-of-study'],
  },
  {
    id: 4,
    title: 'Degrees awarded',
    icon: <DegreesAwardedIcon />,
    value: PageSectionIds['degrees-awarded'],
  },
  {
    id: 5,
    title: 'Admissions',
    icon: <NotebookIcon />,
    value: PageSectionIds.admissions,
  },
  {
    id: 6,
    title: 'Tuition, cost & aid',
    icon: <CalculatorIcon />,
    value: PageSectionIds['tuition-cost-aid'],
  },
  {
    id: 7,
    title: 'Scholarships',
    icon: <PrizeIcon />,
    value: PageSectionIds.scholarship,
  },
  {
    id: 8,
    title: 'Students outcomes',
    icon: <CubesIcon />,
    value: PageSectionIds['students-outcomes'],
  },
  {
    id: 9,
    title: 'Extracurricular activities',
    icon: <TargetIcon />,
    value: PageSectionIds['extracurricular-activities'],
  },
];
